import React from 'react';

export default props => {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>icon_crossmark_1</title>
      <desc>Created with Sketch.</desc>
      <defs />
      <g
        id="Final-Round"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
      >
        <g
          id="Desktop"
          transform="translate(-1292.000000, -1993.000000)"
          stroke="#5B6B7D"
          strokeWidth="3"
        >
          <g id="4th_FAQ" transform="translate(0.000000, 1871.000000)">
            <g id="Group-5" transform="translate(132.000000, 112.000000)">
              <g
                id="icon_crossmark_1"
                transform="translate(1162.000000, 12.000000)"
              >
                <path d="M0,0 L12,12" id="Line-2" />
                <path d="M12,0 L0,12" id="Line-2" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/close.js